import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Plus, Tags, Clock, DollarSign, Edit2 } from 'lucide-react';
import { StatusBadge } from './components/StatusBadge';
import { ClassTypeModal } from './components/ClassTypeModal';
import { useAdminData } from '../contexts/AdminDataContext';
export function AdminClassTypes() {
  const {
    classTypes,
    saveClassType
  } = useAdminData();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedClassType, setSelectedClassType] = useState<any>(null);
  const handleEdit = (classType: any) => {
    setSelectedClassType(classType);
    setIsModalOpen(true);
  };
  const handleNew = () => {
    setSelectedClassType(null);
    setIsModalOpen(true);
  };
  const handleSave = (data: any) => {
    if (selectedClassType) {
      saveClassType({
        ...selectedClassType,
        ...data
      });
    } else {
      saveClassType(data);
    }
    setIsModalOpen(false);
  };
  return <div className="space-y-6" data-id="element-111">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-112">
        <div data-id="element-113">
          <h1 className="font-display text-3xl font-bold text-earth mb-2" data-id="element-114">
            Tipos de Clase
          </h1>
          <p className="text-stone" data-id="element-115">
            Configura las modalidades y precios de tus clases.
          </p>
        </div>
        <button onClick={handleNew} className="flex items-center gap-2 bg-sage text-white px-5 py-2.5 rounded-xl font-semibold hover:bg-sage/90 transition-colors shadow-sm" data-id="element-116">
          <Plus size={18} data-id="element-117" />
          Nuevo Tipo
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-118">
        {classTypes.map((ct, index) => <motion.div key={ct.id} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: index * 0.1
      }} className={`bg-white rounded-2xl border ${ct.is_active ? 'border-mist' : 'border-mist/50 opacity-75'} shadow-sm overflow-hidden flex flex-col`} data-id="element-119">
            <div className="p-6 flex-1" data-id="element-120">
              <div className="flex justify-between items-start mb-4" data-id="element-121">
                <div className="w-12 h-12 bg-sand rounded-xl flex items-center justify-center text-sage" data-id="element-122">
                  <Tags size={24} data-id="element-123" />
                </div>
                <StatusBadge status={ct.modality} data-id="element-124" />
              </div>

              <h3 className="font-display text-xl font-bold text-earth mb-2" data-id="element-125">
                {ct.name}
              </h3>
              <p className="text-stone text-sm mb-6" data-id="element-126">{ct.description}</p>

              <div className="flex items-center gap-6 text-sm text-stone font-medium" data-id="element-127">
                <div className="flex items-center gap-1.5" data-id="element-128">
                  <Clock size={16} className="text-sage" data-id="element-129" />
                  {ct.duration} min
                </div>
                <div className="flex items-center gap-1.5" data-id="element-130">
                  <DollarSign size={16} className="text-sage" data-id="element-131" />$ {ct.price}
                </div>
              </div>
            </div>

            <div className="p-4 border-t border-mist bg-sand/10 flex justify-between items-center" data-id="element-132">
              <span className={`text-xs font-bold uppercase tracking-wider ${ct.is_active ? 'text-success' : 'text-stone'}`} data-id="element-133">
                {ct.is_active ? 'Activo' : 'Inactivo'}
              </span>
              <button onClick={() => handleEdit(ct)} className="flex items-center gap-2 text-sm font-semibold text-earth hover:text-sage transition-colors" data-id="element-134">
                <Edit2 size={16} data-id="element-135" />
                Editar
              </button>
            </div>
          </motion.div>)}
      </div>

      <ClassTypeModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSave={handleSave} classType={selectedClassType} data-id="element-136" />
    </div>;
}